"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusIcon = exports.ErrorSvg = exports.WarningSvg = exports.InfoSvg = exports.SuccessSvg = void 0;
var tslib_1 = require("tslib");
var raw_1 = require("@tableau/icons/ExcludeBaseIcon/raw");
var raw_2 = require("@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon/raw");
var raw_3 = require("@tableau/icons/NotificationCheckIcon/raw");
var raw_4 = require("@tableau/icons/NotificationInfoOutlineIcon/raw");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../gen-src/Localize");
var Colors_1 = require("../styles/Colors");
var DomWidgets_1 = require("../widgets/DomWidgets");
var Icons_1 = require("./Icons");
var SuccessSvg = function () { return raw_3.NotificationCheckIconRaw(14, Colors_1.IconFillColors.Valid); };
exports.SuccessSvg = SuccessSvg;
var InfoSvg = function () { return raw_4.NotificationInfoOutlineIconRaw(14, Colors_1.IconFillColors.Info); };
exports.InfoSvg = InfoSvg;
var WarningSvg = function () { return raw_2.NotificationAlertLowShieldOutlineBaseIconRaw(14, Colors_1.IconFillColors.Warning); };
exports.WarningSvg = WarningSvg;
var ErrorSvg = function () { return raw_1.ExcludeBaseIconRaw(14, Colors_1.IconFillColors.Error); };
exports.ErrorSvg = ErrorSvg;
var ImgSrcMap = {
    error: Icons_1.encodeSvg(exports.ErrorSvg()),
    warning: Icons_1.encodeSvg(exports.WarningSvg()),
    info: Icons_1.encodeSvg(exports.InfoSvg()),
    success: Icons_1.encodeSvg(exports.SuccessSvg()),
};
var StatusIconStyleName = TypeStyle.style({
    height: 14,
    width: 14,
});
function getAltText(type) {
    return Localize_1.Messages[type + "ToastPrefix"]();
}
var StatusIcon = function (_a) {
    var type = _a.type, htmlAttrs = tslib_1.__rest(_a, ["type"]);
    return React.createElement(DomWidgets_1.Img, tslib_1.__assign({ alt: getAltText(type), key: type + "_statusIcon", role: undefined, src: ImgSrcMap[type], title: getAltText(type) }, htmlAttrs, { className: TypeStyle.classes(htmlAttrs.className, StatusIconStyleName) }));
};
exports.StatusIcon = StatusIcon;
//# sourceMappingURL=StatusIcons.js.map